import spartaEventsUtility from "global/sparta-events-utility";
import spartaGlobalFunctions from "global/sparta-global-functions-utility";
import spartaStoreUtility from "global/sparta-store-utility";
import Handlebars from "vendor/handlebars";
import hbs from "vendor/handlebars";
import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import spartaBootstrapUtility from "global/sparta-bootstrap-utility";
import spartaTransportUtility from "global/sparta-transport-utility";
import spartaMessageUtility from "global/sparta-messaging-utility";
import spartaRequireUtility from "global/sparta-require-utility";
import moduleContainer from "helpers/module-container";
export default class Communicator {
    constructor(options) {
        let defaults = {
            public: "document",
            $public: $(),
            private: "",
            $private: $(),
            namespace: "generic"
        };
        this.settings = {};
        this.settings.events = defaults;
        $.extend(this.settings, options);
        this.communication = this.settings.events;
        this.communication.$private = this.settings.$target;
        this.communication.$public = $(this.communication.public);
    }

    beacon(action, params) {



        let utilities = {
          array: {
            slice: function( array ) {
              return Array.prototype.slice.apply(
                array, Array.prototype.slice.call( arguments, 1 )
              );
            },

            remove: function( array, item ) {
              var i, l = array.length;
              for ( i = 0; i < l; i++ ) {
                if ( array[ i ] === item ) {
                  array.splice( i, 1 );
                  i--;
                }
              }
            }
          },  

          functional: function( f ) {
            var slice = utilities.array.slice,
              prepended = [],
              appended = [],
              boundTo = null,
              before,
              after;

            function wrapper() {
              if ( before != null ) {
                before.apply( null, arguments );
              }

              var result = f.apply( boundTo, prepended.concat( slice( arguments ), appended ) );

              if ( after != null ) {
                after.call( null, result );
              }

              return result;
            }

            wrapper.bindTo = function( to ) {
              boundTo = to;
              return wrapper;
            };

            wrapper.append = function() {
              appended = slice( arguments );
              return wrapper;
            };

            wrapper.prepend = function() {
              prepended = slice( arguments );
              return wrapper;
            };

            wrapper.before = function( f ) {
              before = f;
              return wrapper;
            };

            wrapper.after = function( f ) {
              after = f;
              return wrapper;
            };

            return wrapper;
          }
        }


        if (typeof params.context !== "string") return;
        let $location = (params.scope === "public") ? this.communication.$public : this.communication.$private;
        if (action === "listen" && typeof params.callback === "function") {
            $location.on(params.context + "." + this.communication.namespace, utilities.functional(params.callback).bindTo(params.caller));
        }
        if (action === "emit") {
            $location.trigger(params.context + "." + this.communication.namespace, [params.data]);
        }
    }

    listen(params) {
        this.beacon("listen", params);
    }

    emit(params) {
        this.beacon("emit", params);
    }
}